import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import { CirclePicker } from 'react-color'
import { GROUPS_COLORS } from '../../utils/constantes'

const ColorPickerModal = ({
  isOpen,
  setIsOpen = () => {},
  onConfirm = () => {},
  color,
  dismissable = true,
}) => {
  const cancel = (_, reason) => {
    const isClickOutside = reason === 'backdropClick'
    if (dismissable || (!dismissable && !isClickOutside)) {
      setIsOpen(false)
    }
  }

  const confirm = (nextColor) => {
    onConfirm(nextColor)
    setIsOpen(false)
  }

  return (
    <Dialog open={isOpen} onClose={cancel}>
      <DialogTitle>Selectionne une couleur</DialogTitle>
      <DialogContent>
        <CirclePicker onChange={confirm} color={color} colors={GROUPS_COLORS} />
      </DialogContent>
    </Dialog>
  )
}
export default ColorPickerModal
